export const APPROVE_ALL = 'approve_all';
export const PUBLISH_AND_MODERATE = 'publish_and_moderate';
export const REQUIRE_APPROVAL = 'require_approval';
